import { IRootState } from '@src/redux/root.state';

export const selectActiveMembersCount = (state: IRootState): number => state.admin.activeMembersCount;
export const selectInactiveMembersCount = (state: IRootState): number => state.admin.inactiveMembersCount;
export const selectLastMassUpdateSendingDate = (state: IRootState): Date =>
  state.admin.lastMassUpdateSendingDate;
